import { Database } from "@/integrations/supabase/types";

type Weekday = Database["public"]["Enums"]["weekday"];

export const DAYS = [
  { value: 'monday' as Weekday, label: 'Lunes' },
  { value: 'tuesday' as Weekday, label: 'Martes' },
  { value: 'wednesday' as Weekday, label: 'Miércoles' },
  { value: 'thursday' as Weekday, label: 'Jueves' },
  { value: 'friday' as Weekday, label: 'Viernes' },
  { value: 'saturday' as Weekday, label: 'Sábado' },
  { value: 'sunday' as Weekday, label: 'Domingo' },
];

export const getDayLabel = (day: Weekday): string => {
  return DAYS.find(d => d.value === day)?.label || day;
};